import { ReactComponent as NotificationIcon } from 'assets/icons/notification.svg'
import { ReactComponent as NotificationUnread } from 'assets/icons/notificationsUnread.svg'
import { IconButton, Link } from 'ui'

import style from './Notification.module.scss'

export type TNotification = {
  isNotification: boolean
  handleClick: () => void
}

// индикатор уведомлений в боковом меню
export function NotificationIndicator({
  isNotification,
  handleClick,
}: TNotification) {
  return (
    <Link
      href='/notice'
      underline='none'
      className={style.link}
      onClick={handleClick}
    >
      <IconButton>
        {isNotification && <NotificationUnread />}
        {!isNotification && <NotificationIcon />}
      </IconButton>
    </Link>
  )
}
